import * as Yup from "yup";

export const validation = Yup.object().shape({
  // title: Yup.string().required('Title is required'),
});

export const model = {
  title: "",
  instruction: "",
  options: [],
};

export const members = [
  {
    first: "Jurriaan van der Broek",
    last: "Broek",
    value: 1,
    info: "Machine learning",
  },
  {
    first: "Gopichand",
    last: "Sana",
    value: 2,
    info: "Robotics",
  },
  {
    first: "Chiemeka ",
    last: "Yobachukwu",
    value: 3,
    info: "Conversational interfaces",
  },
  {
    first: "Jurriaan van der Broek",
    last: "Broek",
    value: 4,
    info: "Machine learning",
  },
  {
    first: "Gopichand",
    last: "Sana",
    value: 5,
    info: "Robotics",
  },
  {
    first: "Chiemeka ",
    last: "Yobachukwu",
    value: 6,
    info: "Conversational interfaces",
  },
];

export const optionEvaluation = [
  {
    text: "Default",
    value: "default",
  },
];

export const USERS_WIZARD_SEARCH = "councils/users/search";
